import {Component, Inject, OnInit} from '@angular/core';
import {
	NotificationModel,
	NotificationPriority
} from '../../../notification-center/models/notification.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateContext} from '@shared/pipes/translate.pipe';
import {NotificationsService} from '../../../notification-center/services/notifications.service';

@Component({
	selector: 'amd-notification-dialog',
	templateUrl: './notification-dialog.component.html',
	styleUrls: ['./notification-dialog.component.scss']
})
export class NotificationDialogComponent implements OnInit {

	notification: NotificationModel;
	notificationList: NotificationModel[];
	translateContext: TranslateContext = TranslateContext.NOTIFICATION_CENTER;
	notificationPriority: typeof NotificationPriority = NotificationPriority;
	showLoader: boolean;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: NotificationModel[],
		public dialogRef: MatDialogRef<NotificationDialogComponent>,
		private notificationService: NotificationsService
	) {
		this.notificationList = data;
		this.notification = this.notificationList[0];
	}

	ngOnInit(): void {
	}

	goNext(): void {
		const i: number = this.notificationList.indexOf(this.notification);
		if (i === this.notificationList.length - 1) {
			this.setRead();
		} else {
			this.notification = this.notificationList[i + 1];
		}
	}

	private setRead(): void {
		this.showLoader = true;
		this.notificationService.setRead(this.notificationList.map(notification => notification.notification_id))
			.subscribe(resp => {
				this.showLoader = true;
				if (resp.ok) {
					this.dialogRef.close();
				}
			});
	}
}
